function initFeaturedCollectionSliders() {
  // Get all instances of the featured collection sliders
  $('.featured-collection-wrapper .featured-collection-slider--enabled').each(function () {
    const $slider = $(this);
    
    // Check if the slider is already initialized
    if (!$slider.hasClass('slick-initialized')) {
      const mobileCol = parseInt($slider.attr('data-mobile-col')) || 1;
      const desktopCol = parseInt($slider.attr('data-desktop-col')) || 1;

      // Initialize Slick slider
      $slider.slick({
        infinite: false,
        slidesToShow: desktopCol,
        slidesToScroll: 1,
        prevArrow: '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg class="icon--icon-next" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: mobileCol
            }
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: desktopCol
            }
          }
        ]
      });
    }
  });
}

// Shopify Theme Editor support
document.addEventListener('shopify:section:load', initFeaturedCollectionSliders);
document.addEventListener('shopify:section:select', initFeaturedCollectionSliders);
document.addEventListener('shopify:section:deselect', initFeaturedCollectionSliders);
document.addEventListener('shopify:block:select', initFeaturedCollectionSliders);
document.addEventListener('shopify:block:deselect', initFeaturedCollectionSliders);

// Optional: Only destroy sliders from that section on unload
document.addEventListener('shopify:section:unload', function (event) {
  const section = event.target;
  $(section).find('.featured-collection-slider--enabled.slick-initialized').slick('unslick');
});

// On initial page load
document.addEventListener('DOMContentLoaded', initFeaturedCollectionSliders);
